export default __webpack_public_path__ + "static/homepage_feedback-e3e2c7502a2024751820b78128e54390.mp4";